module.exports = __webpack_public_path__ + "img/user_avatar.c377377f.png";